import React, { Fragment, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { makeStyles, createStyles, useTheme } from '@material-ui/core/styles';
import { Theme, Typography } from '@material-ui/core';


let useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: theme.breakpoints.values.md,
      maxWidth: '100%',
      margin: '0 auto',
      padding: theme.spacing(3, 3, 6, 3)
    }
  })
);

let PageDetail = ({ children, title }: IPageDetailProps) => {
  let theme = useTheme();
  let classes = useStyles(theme);


  return (
    <Fragment>
      <Helmet title="Videndum Media Solutions" />
      <div className={classes.root}>
        <Typography component="h1" variant="h3" gutterBottom>
          {title}
        </Typography>

        {children}
      </div>
    </Fragment>
  );
};

interface IPageDetailProps {
  children: ReactNode
  title: string
};

export default PageDetail;